// extracted by mini-css-extract-plugin
export default {"table":"y07edJx"};